/*************************************************/
/* MMENU                                         */
/*************************************************/
import Mmenu from 'mmenu-js';

export function mmenu() {
    let mobileMenu,
        mobileMenuTrigger;

    const mobileMenuSelector = '#mobile-menu',
        mainContentSelector = '#mainContent';

    const init = function () {
        mobileMenu = document.querySelector(mobileMenuSelector);
        mobileMenuTrigger = document.querySelector('.mm-trigger');
        const deactivated = document.querySelectorAll('.mobile-menu__main__link--disabled');

        const linkedInUrl = mobileMenu.getAttribute('data-linkedin-url') || '#';

        //Init mmenu
        const menu = new Mmenu(mobileMenuSelector, {
            slidingSubmenus: false,
            navbar: {
                title: " "
            },
            offCanvas: {
                use: true,
                position: "right"
            },
            "navbars": [
                {
                    "position": "top",
                    "content": [
                        "prev",
                        "title",
                        '<div class="menu-nav-mobile__close"></div>'
                    ]
                },
                {
                    "position": "bottom",
                    "content": [
                        '<div class="menu-nav-mobile__linkedin"></div>'
                    ]
                }
            ]
        }, {
            offCanvas: {
                page: {
                    nodeType: "main",
                    selector: mainContentSelector
                }
            }
        });
        const mmenuApi = menu.API;

        // 2. Inject the dynamic link into the mmenu structure
        // We look inside the mobileMenu (which mmenu has now processed)
        const linkedInContainer = mobileMenu.querySelector('.menu-nav-mobile__linkedin');
        if (linkedInContainer) {
            linkedInContainer.innerHTML = `<a href="${linkedInUrl}" target="_blank" rel="noopener">LinkedIn</a>`;
        }

        // Open menu
        mobileMenuTrigger.addEventListener('click', () => {
            if (mmenuApi) {
                mobileMenu.setAttribute('style', '');
                deactivated.forEach(event => {
                    event.addEventListener('click', () => {
                        event.nextElementSibling.click();
                    })
                })
                mmenuApi.open();
            }
        });

        var menuCloseBtn = document.querySelector(".menu-nav-mobile__close");
        menuCloseBtn.addEventListener('click', () => {
            if (mmenuApi) {
                mmenuApi.close();
            }
        })

        // Close mmenu if screen width gets over breakpoint
        var mediaQuery = window.matchMedia("(min-width: 768px)");
        mediaQuery.addEventListener("change", function () {
            if (mmenuApi) {
                mmenuApi.close();
            }
        });
    };

    init();
}
